import { useEffect, useState } from "react";
import UsersServices from "../../services/utilisateur/UsersService";

function useUsers() {
  const [users, setUsers] = useState([]);
  const [oneUser, setOneUser] = useState({});

  // ✅ Corrigé
  function fetchUsers() {
    return UsersServices.getAll()
      .then((res) => {
        if (Array.isArray(res.data.data)) {
          const filteredUsers = res.data.data.filter(
            (user) => !(user.role === 1 ),
          );
          setUsers(filteredUsers);
        } else {
          console.error("La réponse de l'API n'est pas un tableau.");
        }
      })
      .catch((err) => console.error("Erreur API :", err));
  }

  const getOneUser = (id, callback = () => {}) => {
    UsersServices.getOne(id)
      .then((res) => {
        setOneUser(res.data.data);
        callback(res.data.data);
      })
      .catch((err) => console.error(err));
  };

  const createUser = (data, callback = () => {}) => {
    UsersServices.create(data)
      .then(() => {
        fetchUsers();
        callback();
      })
      .catch((err) => console.error(err));
  };

  const generateFile = (data, callback = () => {}) => {
    UsersServices.generateFile(data)
      .then(() => {
        callback();
      })
      .catch((err) => console.error(err));
  };

  const updateUser = (id, data, callback = () => {}) => {
    UsersServices.update(id, data)
      .then(() => {
        fetchUsers();
        callback();
      })
      .catch((err) => console.error(err));
  };

  const deleteUser = (id, callback = () => {}) => {
    UsersServices.delete(id)
      .then(() => {
        fetchUsers();
        callback();
      })
      .catch((err) => console.error(err));
  };

  const checkBuildStatus = (callback = () => {}) => {
    UsersServices.checkBuildStatus()
      .then((res) => {
        callback(res.data?.isBuilding);
      })
      .catch((err) => {
        console.error("Erreur lors de la vérification du build :", err);
        callback(false);
      });
  };

const getSuperviseurByEntrepriseId = (data, callback = () => {}) => {
  UsersServices.getSuperviseurByEntrepriseId(data)
    .then((res) => {
      const filteredUsers = Array.isArray(res?.data)
        ? res.data.filter(
            (user) => {
              return !(user.role === 1 )
            }
          )
        : res?.data;

      callback(filteredUsers);
    })
    .catch((err) => {
      console.error("Erreur lors de la récupération :", err);
      callback(false);
    });
};

  const updatePDP = (id, file, callback = () => {}) => {
    UsersServices.updatePDP(id, file)
      .then((res) => {
        callback(res.data);
      })
      .catch((err) => console.error(err));
  };

  return {
    oneUser,
    users,
    createUser,
    updateUser,
    deleteUser,
    setUsers,
    generateFile,
    getOneUser,
    checkBuildStatus,
    getSuperviseurByEntrepriseId,
    updatePDP,
    fetchUsers,
  };
}

export default useUsers;
